import { numberInputStyleWithoutArrow, Themes } from '../../../../../../../constants';
import { FHInputField } from '../../../../../../base';
import { cleanNumericInputValue } from '../../../../../../../helpers';

import type { ChangeEvent } from 'react';

const NumericInput = ({
  value,
  onChange,
  error,
  testId,
  disabled,
  sx = {},
}: {
  value: number | string | null;
  onChange: (value: string | null) => void;
  error?: boolean;
  testId?: string;
  sx?: object;
  disabled?: boolean;
}) => (
  <FHInputField
    data-testid={testId}
    sx={{
      width: 45,
      minWidth: 45,
      borderRadius: 1.5,
      ...sx,
      ...numberInputStyleWithoutArrow,
    }}
    type="text"
    inputHeight={40}
    colorTheme={Themes.Primary}
    coloredBackground
    disabled={disabled}
    value={value ?? ''}
    onChange={(e: ChangeEvent<HTMLInputElement>) => {
      const cleanValue = cleanNumericInputValue(e.target.value);
      const numValue = cleanValue === '' ? null : cleanValue;
      onChange(numValue);
    }}
    error={error}
  />
);

export default NumericInput;
